/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';

export function Radio({id, name, label, ...props}) {

    return <React.Fragment>
        <div className="p-radio">
            <input id={id} type="radio" name={name} {...props} />
            <label htmlFor={id}>{label}</label>
        </div>
    </React.Fragment>

}
